import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UserTrackerConsent } from '../../models/userTrackConsent.model';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-consent-details-modal',
  templateUrl: './consent-details-modal.component.html',
  styleUrls: ['./consent-details-modal.component.scss'],
  standalone: true,
  imports: [MatDialogModule, DatePipe]
})
export class ConsentDetailsModalComponent {

  constructor(
    private dialogRef: MatDialogRef<ConsentDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UserTrackerConsent
  ) {}

  close() {
    this.dialogRef.close();
  }
}
